import food from "../Asset/food.png";
import fdcal from "../Asset/fd-cal.png";
import weather from "../Asset/weather.png";
import music from "../Asset/musicweb.png";
import auth from "../Asset/Authentication.png"
import { Link } from "react-router-dom";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import live from '../Asset/live.svg'

import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(useGSAP,ScrollTrigger);



const Project = () => {
  const projects = [
    {
      id: 1,
      title: "Food Delivery",
      image: food,
      link: "https://arbazfooddelivery.netlify.app/",
      content:" Introducing my personal project: a sleek food delivery , website built with React for the frontend and Firebase for the backend.Enjoy seamless browsing, ordering, and delivery tracking in this user-friendly platform",


    
    },
    
    {
      id: 2,
      title: "FD-Calculator",
      image: fdcal,
      link: "https://exquisite-sopapillas-df8502.netlify.app/",
      content:" A NextJS project featuring an investment calculator and target planner. Users input investment details, receiving results through tables and line charts. The user-friendly interface aids financial planning, facilitating quick decision-making on potential returns.  💰🚀"

    },
    {
      id: 3,
      title: "Weather",
      image: weather,
      link: "https://arbaazweatherapp.netlify.app/",
      content:"         Introducing my personal project: a sleek weather app , website built with React for the frontend ."
      
    },
    {
      id: 4,
      title: "Music Web",
      image: music,
      link: "https://web-music-player-react.netlify.app/",
      content:" Introducing my personal project: a sleek web-music player ,website built with React for the frontend "
    }
    ,
    {
      id: 5,
      title: "Authentication",
      image: auth,
      link: "https://aquamarine-salmiakki-f2d2fa.netlify.app/",
      content:"Developed a backend authentication solution with Node.js, Express, and MongoDB, integrating Google reCAPTCHA for enhanced security."
    },

  ]
  useGSAP(() => {

  
   
    gsap.from("#projectss", { y: 50, opacity: 0.7 ,duration: 1.5,  ease:  "ease.in", delay: 1, scrollTrigger:{trigger:"#projectss",toggleActions:"restart none  reverse pause"} })
  },)






  return (

    <>
      <h1 className=" lg:text-5xl  text-4xl font-bold   text-blue-600  underline underline-offset-8    p-4   font-serif tracking-widest " id="projects">
        Projects
        <br />
     
      </h1>



      <div className="  "> 
      {projects.map((project) => (


        <div key={project.id} className="flex flex-col  justify-center items-center   p-4" id="projectss">

        <div className="flex justify-center ">
          <h1 className="text-3xl  font-bold m-4 font-serif uppercase letter-spacing-4 tracking-widest">{project.title}</h1>
          </div>


       
      <div className="flex  flex-col lg:flex-row-reverse  shadow-lg shadow-opacity-50 shadow-silver-400 bg-fuchsia-200  lg:w-5/6 border-4 opacity-80  p-8 justify-center w-full items-center ">
      <img  src={project.image}  alt="AirMax Pro "
        className=" rounded-md object-cover  w-full lg:w-1/3" />

        <div className="flex flex-col  justify-center items-center  ">
        <p className="text-center justify-center  mt-6 lg:mt-0  ">{project.content}</p>
        <Link to={project.link} target="_blank" className="mt-6 cursor-pointer hover:text-amber-600">
        <img src={live} alt="live" className="mt-6 cursor-pointer hover:text-amber-600" /></Link>

        </div>
   


    

      </div>
          
             
       
      
      </div>
    

      ))}  </div>
        

    
    </>
  );
};
export default Project;
